import { EffectHandler } from "../types/editor"

const MultiSpeakerHandler: EffectHandler = {
    // 添加
    addEffect(editor, selection, value) {
        const speaker = editor.speakerUtils.getSpeakerById(value.speakerId)
        editor.addcontainEffectHtml({
            range: selection.range,
            effectType: 'multiSpeaker',
            effectUIType: 'multiSpeakerInner',
            idName: 'hover',
            param: {
                speed: value.speed,
                pitch: value.pitch,
                speakerName: speaker.name,
                speakerName2: speaker.name.split("|")[0],
                speakerId: value.speakerId,
                gender: speaker.gender,
                speaker: speaker.speaker,
                speakerSource: speaker.source,
                emotionWeight: value.emotionWeight,
            }
        })
    },
    // 修改
    modifyEffect(editor, selection, value) { },
    // 删除
    removeEffect(editor, selection) { },
}
export default MultiSpeakerHandler